import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { Location } from 'vue-router'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'
import loc from '~/utils/loc'

interface LetterItem {
  code: string,
  active: boolean
}

const al = 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЫЭЮЯ'

interface Slider {
  next: () => void,
  prev: () => void
}

@Component
export default class DiseaseFilter extends Vue {
  al: string[] = al.split('')

  options = {
    slidesToShow: 27,
    arrows: false,
    slidesToScroll: 10,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 17,
          slidesToScroll: 8
        }
      },
      {
        breakpoint: 490,
        settings: {
          slidesToShow: 11,
          slidesToScroll: 4
        }
      }
    ]
  }

  @Ref()
  readonly slider!: Slider

  @Prop({ required: true, type: Array })
  readonly activeLetters!: string[]

  get selected () {
    const val = this.$route.query?.letter
    if (typeof val === 'string') {
      return val.toUpperCase()
    }
    return ''
  }

  get items (): LetterItem[] {
    return this.al.map(e => ({
      active: this.activeLetters.map(letter => letter.toUpperCase()).includes(e.toUpperCase()),
      code: e.toUpperCase()
    }))
  }

  get code (): string {
    return JSON.stringify(this.items)
  }

  next () {
    this.slider.next()
  }

  prev () {
    this.slider.prev()
  }

  renderList () {
    return this.items.map((e) => {
      const query: { [key: string]: string } = {
        letter: e.code
      }

      if (typeof this.$route.query?.section === 'string') {
        query.section = this.$route.query?.section
      }

      const location: Location = loc(this.$store, {
        name: 'diseases',
        query
      })

      const classes = {
        'disease-filter__item': true,
        'disease-filter__item_disable': !e.active,
        'disease-filter__item_selected': e.code === this.selected
      }
      return [
        <nuxt-link to={location} class={classes}>
          {e.code}
        </nuxt-link>,
        <div class="disease-filter__item-circle">
        </div>
      ]
    })
  }

  renderSliderItem (e: LetterItem) {
    const query: { [key: string]: string } = {
      letter: e.code
    }

    if (typeof this.$route.query?.section === 'string') {
      query.section = this.$route.query?.section
    }

    const location: Location = loc(this.$store, {
      name: 'diseases',
      query
    })

    const classes = {
      'disease-filter__item': true,
      'disease-filter__item_disable': !e.active,
      'disease-filter__item_selected': e.code === this.selected
    }
    return [
      <div class="disease-filter__slider-item-wrapper">
        <nuxt-link to={location} class={classes}>
          {e.code}
        </nuxt-link>
      </div>,
      <div class="disease-filter__slider-item-wrapper">
        <div class="disease-filter__item-circle">
        </div>
      </div>
    ]
  }

  render () {
    return (
      <div class="disease-filter">
        <div class="disease-filter__list">
          {this.renderList()}
        </div>
        <div class="disease-filter__slider">
          <div class="disease-filter__prev" onClick={this.prev}>
            <ArrowSvg />
          </div>
          <div class="disease-filter__track">
            <client-only>
              <slick options={this.options} ref="slider">
                {this.items.map(e => this.renderSliderItem(e))}
              </slick>
            </client-only>
          </div>
          <div class="disease-filter__next" onClick={this.next}>
            <ArrowSvg />
          </div>
        </div>
      </div>
    )
  }
}
